import { render, staticRenderFns } from "./TableBlueLabelBalance.vue?vue&type=template&id=088974a9&scoped=true&"
import script from "./TableBlueLabelBalance.vue?vue&type=script&lang=js&"
export * from "./TableBlueLabelBalance.vue?vue&type=script&lang=js&"
import style0 from "./TableBlueLabelBalance.vue?vue&type=style&index=0&id=088974a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088974a9",
  null
  
)

export default component.exports